"use client";

import { Select } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";
import { InputField } from "@/components/form";
import { arrayToDictionary } from "@/features/customer-information/utils";
import { DigitsInputField } from "./digits-input-field";

interface AccountNumberFieldProps {
	name: string;
	label: string;
	accountNumbers?: string[];
	selectLabel?: string;
	readOnly?: boolean;
	/** SE: restrict entry to digits and cap it at `maxDigits`. */
	digitsOnly?: boolean;
	maxDigits?: number;
}

export const AccountNumberField = ({
	name,
	label,
	accountNumbers,
	selectLabel,
	readOnly,
	digitsOnly,
	maxDigits,
}: AccountNumberFieldProps) => {
	const hasMultiple = (accountNumbers?.length ?? 0) > 1;

	if (hasMultiple) {
		const options = Object.entries(arrayToDictionary(accountNumbers ?? [])).map(
			([value, optionLabel]) => ({ value, label: optionLabel })
		);

		return (
			<FormField
				name={name}
				render={({ field }) => (
					<Select
						label={selectLabel ?? label}
						options={options}
						{...field}
						value={field.value ?? ""}
					/>
				)}
			/>
		);
	}

	// FI holds an IBAN, so digit-stripping is SE-only.
	if (digitsOnly) {
		return <DigitsInputField name={name} label={label} maxDigits={maxDigits} />;
	}

	return <InputField name={name} label={label} readOnly={readOnly} />;
};
